import { useMediaQuery, useTheme } from "@mui/material";
import { useEffect } from "react";
import { BehaviorSubject } from "rxjs";

export const DEFAULT_HIDDEN = false;
export const subjectHideHeader = new BehaviorSubject(DEFAULT_HIDDEN);

export default function useHideHeader(hide) {
  const theme = useTheme();
  const isNotMobile = useMediaQuery(theme.breakpoints.up("sm"));

  useEffect(() => {
    subjectHideHeader.next(isNotMobile && hide);

    return () => subjectHideHeader.next(DEFAULT_HIDDEN);
  }, [hide, isNotMobile]);
}
